import { satc_periodDetailsHistory } from "Constants/TableColumns";
import addNumToList from "Helpers/addNumToList";
import RemoteTable from "Components/RemoteTable/RemoteTable";

export default function PeriodDetailsHistory({ data }) {
  return (
    <RemoteTable
      data={addNumToList(data, 1, 0)}
      columns={satc_periodDetailsHistory}
      noTitle={true}
      showPagination={false}
    />
  );
}
